/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Error_Href1Inputs */

const vi_sitesettings_error_href1 = /** @type {(inputs: Sitesettings_Error_Href1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn phải bắt đầu bằng / (vd /tra-cuu-don) hoặc http:// / https://, không có dấu cách.`)
};

/**

* @param {Sitesettings_Error_Href1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_error_href1 = /** @type {((inputs?: Sitesettings_Error_Href1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Error_Href1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_error_href1(inputs)
});
export { sitesettings_error_href1 as "siteSettings_error_href" }